<template>
  <div class="logo-block">
    <a href="https://www.africa.undp.org" target="_blank" title="Africa UNDP">
      <div class="app-logo">
        <logo-img class="logo-img" />
        <h2 class="site-title">
          <span>African Influencers</span>
          <span>for Development</span>
          <span>Business Map</span>
        </h2>
      </div>
    </a>
    <a class="help-icon" @click="$emit('showHelp')" title="About the map" />
    <v-dialog v-model="showHelp" scrollable max-width="70%" height="100%">
      <help-content @close="$emit('hideHelp')" ref="helpContainer" />
    </v-dialog>
  </div>
</template>

<script>
import helpContent from '@/components/help-content'
import logoImg from '@/assets/img/logo.svg?inline'

export default {
  name: 'app-logo',
  components: {
    logoImg,
    helpContent,
  },
  props: {
    isHelpShown: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showHelp: {
      get() {
        return this.isHelpShown
      },
      set(val) {
        if (val) {
          this.$emit('showHelp')
        } else {
          this.$emit('hideHelp')
        }
      },
    },
  },
}
</script>

<style scoped lang="scss">
.logo-block {
  position: relative;
  a {
    text-decoration: none;
  }
}
.site-title {
  font-size: 12px;
  font-weight: normal;
  padding: 7px 0px 0px 40px;
  span {
    display: block;
    color: #155ead;
  }
}
.logo-img {
  position: absolute;
}
.help-icon {
  top: 12px;
  position: absolute;
  right: 0;
  &:before {
    background: #fff;
    border-radius: 24px;
    border: 1px solid #155ead;
    color: #155ead;
    content: '?';
    display: inline-block;
    font-family: sans-serif;
    font-size: 19px;
    font-weight: normal;
    height: 28px;
    line-height: 26px;
    padding: 0;
    text-align: center;
    text-decoration: none;
    width: 28px;
  }
  &:hover:before {
    background: #155ead;
    color: #fff;
    text-decoration: none;
  }
}
</style>
